import React, { useContext, useCallback, useMemo } from 'react';

// GLOBAL FUNCTIONS
import { documentFetch, fileDownload } from 'functions.js';

// GLOBAL HELPERS
import { ListContext } from 'helpers/getListData';

// CORE COMPONENTS
import Button from 'core/tools/Button';
import Tooltip from 'core/tools/Tooltip.js';

// CHILD COMPONENTS
export const ExcelButton = ({
  variant,
  label,
  icon,
  args,
  params
}) => {

  // CALLBACKS
  const handleDownload = useCallback(
    () => {
      documentFetch({
        accept: 'xls/xlsx',
        contentType: 'xls/xlsx',
        mimeType: 'xls/xlsx',
        ...args,
        params: {
          downloadExcel: true,
          ...params
        }
      });
    }, [args, params]
  )

  // RENDER
  return (
    <Tooltip
      variant={variant}
      tip={label}
    >
      <Button.Link
        variant={variant}
        icon={icon}
        onClick={handleDownload}
      />
    </Tooltip>
  )
};
const ListExcelButton = ({
  args,
  includeActiveColumns = true,
  ...props
}) => {

  // CONTEXT
  const { fetchArgs = {}, preferences: { showColumns = [], filters = {} } = {} } = useContext(ListContext) || {};
  const { startRow } = filters || {};

  // MEMOS
  const params = useMemo(
    () =>
      Object.assign(
        {
          activeColumns: includeActiveColumns ? showColumns.toString() : undefined
        },
        {
          ...filters,
          startRow: startRow ? parseInt(startRow) : undefined
        },
        fetchArgs.params,
        args.params
      ),
    [args, fetchArgs, showColumns, startRow, filters, includeActiveColumns]
  );

  // RENDER
  return (
    <ExcelButton
      args={{
        ...args,
        ...fetchArgs
      }}
      params={params}
      {...props}
    />
  )
}

// MAIN COMPONENT
const ExcelButtons = ({
  fileName, //
  label = 'records',
  args,
  tooltip = 'Export to Excel',
  ...props
}) => (
  <>
    {/*
    <ListExcelButton
      variant="primary"
      label="Print Records"
      icon="print"
      args={{
        loadingMessage: `Printing ${label}`,
        errorMessage: `Unable to print ${label}.`,
        onSuccess: filePrint,
        ...args
      }}
      {...props}
    />
    */}
    <ListExcelButton
      variant="success"
      label={tooltip}
      icon="download-excel"
      args={{
        loadingMessage: `Downloading ${label}`,
        errorMessage: `Unable to download ${label}.`,
        onSuccess: ({ url }) => fileDownload(url, fileName, 'xlsx', true),
        ...args
      }}
      {...props}
    />
  </>
)

// EXPORT
export default ExcelButtons;
